module.exports = __webpack_public_path__ + "img/10866_L.125fdd2e.png";